import React from "react";
import {Box,Typography}from "@mui/material";

const BenefitsFeature=({
  number,
  title,
  mainDescription,
  description,
  image,
})=>{
  return(
    <Box className="autobet-benefit-card">
      <Box className="autobet-benefit-card-bg"/>

      <Box className="autobet-benefit-number">
        {String(number).padStart(2,"0")}
      </Box>

      <Box className="autobet-benefit-content">
        <Typography
          component="p"
          className="autobet-benefit-label"
        >
          {title}
        </Typography>

        <Typography
          component="h3"
          className="autobet-benefit-title"
        >
          {title}
        </Typography>

        <Box className="autobet-benefit-title-line"/>

        <Typography
          component="p"
          className="autobet-benefit-description"
        >
          {mainDescription}
        </Typography>

        <Box className="autobet-benefit-detail">
          <Box className="autobet-benefit-detail-dot"/>

          <Typography component="p">
            {description}
          </Typography>
        </Box>
      </Box>

      <Box className="autobet-benefit-visual">
        <img
          src={image}
          alt={title}
        />
      </Box>
    </Box>
  );
};

export default BenefitsFeature;